var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('WebPartPageDiv',{attrs:{"div":_vm.div,"templateName":_vm.templateName}})
}
var staticRenderFns = []

export { render, staticRenderFns }